import React from 'react';
import styled from 'styled-components';
import {mobileMediaQuery} from '../../styles';
import {ReactComponent as CNitoLogo} from '../../assets/cnito_logo_black.svg';
import {getCurrentLang} from '../../utils/i18n';

const FooterCNitoButton = () => {
    let lang = getCurrentLang();
    let url =
        lang === 'pt'
            ? 'https://www.cartoonito.com.br'
            : 'https://www.cartoonito.com';
    return (
        <Container href={url} target="_blank">
            <CNitoLogo />
        </Container>
    );
};

const Container = styled.a`
    position: relative;
    background: url(${require('../../assets/footer_cnito_decoration.png')}),
        #f6d705;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 6px;
    align-items: center;
    justify-content: center;
    display: flex;
    height: 46px;
    overflow: hidden;
    width: 220px;
    margin-bottom: 22px;
    ${mobileMediaQuery} {
        min-width: 290px;
        width: 100%;
    }
`;

export default FooterCNitoButton;
